import React from 'react';

/**
 * Empty / no-data state: icon + title + text + optional CTA.
 * Modeled on the "Today — no dips" board state.
 *
 * props:
 * - title    : string — bold line
 * - text     : string — muted descriptive line
 * - icon     : node   — optional SVG icon (defaults to a generic inbox glyph)
 * - cta      : { label, onClick } — optional call to action button
 */
function EmptyState({ title, text, icon, cta }) {
    const defaultIcon = (
        <svg width="40" height="40" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"
                d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0l-2.5 5a2 2 0 01-1.8 1h-7.4a2 2 0 01-1.8-1L4 13m16 0h-4.6a1 1 0 00-.9.55l-.5 1a1 1 0 01-.9.55h-2.2a1 1 0 01-.9-.55l-.5-1a1 1 0 00-.9-.55H4" />
        </svg>
    );
    return (
        <div className="gh-empty">
            <div className="gh-empty-icon">{icon || defaultIcon}</div>
            {title ? <div className="gh-empty-title">{title}</div> : null}
            {text ? <div className="small">{text}</div> : null}
            {cta ? (
                <div className="mt-3">
                    <button type="button" className="btn btn-sm btn-outline-primary" onClick={cta.onClick}>
                        {cta.label}
                    </button>
                </div>
            ) : null}
        </div>
    );
}

export default EmptyState;
